angular
	.module('HomepageServices')
	.component('createContent', require('./createContent.component.js'))
    .filter('createContentFilter', require('./createContent.filter.js'));


// WEBPACK FOOTER //
// ./app/components/createContent/index.js